export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID as string;

declare global {
  interface Window {
    fbq: (
      type: string,
      eventName: string,
      params?: Record<string, unknown>
    ) => void;
  }
}

export function pageview(): void {
  window.fbq("track", "PageView");
}

export function event(name: string, options: Record<string, unknown> = {}): void {
  window.fbq("track", name, options);
}
